import React, { useEffect, useState } from 'react';
import './convs.css';

const PDF_URL =
  'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/formatos/2026/PBPA/CCOMP.pdf';

const PdfViewer = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);

    if (mobile) {
      window.location.replace(PDF_URL);
    }
  }, []);

  return (
    <div className="pdf-viewer-container">
      <h2 className="pdf-viewer-title">
        Formato
        <br />
        Carta Compromiso
      </h2>

      {!isMobile && (
        <div className="pdf-viewer-wrapper">
          <iframe
            src={PDF_URL}
            title="Visor de PDF"
            className="pdf-viewer-iframe"
          />
        </div>
      )}
    </div>
  );
};

export default PdfViewer;